import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { listReferredAccountsPaged } from '@/modules/affiliates/services/affiliateInsightsService'
import ReferredAccountsTable from '@/modules/affiliates/components/ReferredAccountsTable'
import { Pagination } from '@/shared/ui/Pagination'

export default function MyAfiliacoesPage() {
  const { profile } = useAuth()
  const uid = profile?.id || ''
  const [rows, setRows] = React.useState<any[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)
  const [page, setPage] = React.useState(1)
  const [total, setTotal] = React.useState(0)
  const pageSize = 25

  React.useEffect(() => { (async () => {
    if (!uid) return
    setLoading(true); setError(null)
    try { const { rows, total } = await listReferredAccountsPaged(uid, page, pageSize); setRows(rows); setTotal(total) } catch (e:any) { setError(e?.message || 'Falha ao carregar afiliações') } finally { setLoading(false) }
  })() }, [uid, page])

  return (
    <div className="w-full">
      <h1 className="mb-4 text-2xl font-semibold">Afiliações</h1>
      {error && <div className="mb-3 rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">{error}</div>}
      {loading ? (
        <div className="text-sm text-foreground/70">Carregando...</div>
      ) : (
        <>
          <ReferredAccountsTable rows={rows as any} />
          <div className="mt-4 flex justify-end">
            <Pagination page={page} total={Math.max(1, Math.ceil(total / pageSize))} onChange={setPage} />
          </div>
        </>
      )}
    </div>
  )
}
